/**
 * Function that handles header visibility based on scroll position and direction
 *
 * when header page is scrolled past header, body gets class "sticky-header" and header gets class "offscreen".
 * When scrolled upward, "offscreen" class is removed.
 *
 * Add css styles accordingly (header position absolute at first, fixed when sticky header is active).
 */
import throttle from 'lodash/throttle';

export default function stickyHeader() {

  const header = document.querySelector('.js-sticky-header');
  let headerOffset = 0;
  let lastScrollTop = null;
  let hideTimer;

  if(header) {
    headerOffset = header.offsetTop;
    const scrollThrottle = throttle(handleHeaderVisibility, 50);
    document.addEventListener('scroll', scrollThrottle);
  }

  /**
   * Handle header visibility based on scroll position
   */
  function handleHeaderVisibility() {
    const scrollTop = window.scrollY;

    if (scrollTop > headerOffset) {
      const isGoingDown = scrollTop > lastScrollTop;

      // if we are going down and have passed the header position, hide it after short delay
      if (isGoingDown && scrollTop > headerOffset + header.offsetHeight) {
        hideTimer = setTimeout(handleScrollDown, 200);
      } else {
        clearTimeout(hideTimer);
        handleScrollUp();
      }
    } else {
      //we are at the top
      header.classList.remove('offscreen');
      document.body.classList.remove('sticky-header');
    }
    // save the last scroll position to determine scroll direction
    lastScrollTop = scrollTop;
  }

  /**
   * Hide header while scrolling down
   */
  function handleScrollDown() {
    header.classList.add('offscreen');

    if(!document.body.classList.contains('sticky-header')) {
      //run this after 1 second, so header has time to slide away
      setTimeout(function(){
        // check again that the bar is not at the top (event missed by the throttle)
        if (window.scrollY > headerOffset) {
          document.body.classList.add('sticky-header');
        }
      }, 1000);
    }
  }

  /**
   * Show header while scrolling up
   */
  function handleScrollUp() {
    header.classList.remove('offscreen');
  }
}
